// 登入註冊按鈕
'use client';
import { useDispatch } from 'react-redux';
import { setShowLoginModal } from '@/slices/popSlice';
import { useTranslation } from 'react-i18next';
import Image from 'next/image';

const LoginButton = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    return (
        <div className="relative !rounded-[40px] overflow-hidden group !w-[unset] flex-shrink-0 !border-0">
            <button
                onClick={() => dispatch(setShowLoginModal(true))}
                className="gtm-btn-login h-[32px] relative z-[2] rounded-[40px] text-btn1 text-white flex items-center px-[17px] py-[8px]
                backdrop-filter-[5px] usm:px-[12px] uxs:!px-[10px]"
            >
                <span className="pointer-events-none">{t('LOGIN')}</span>
                <span className="pointer-events-none w-[1px] h-[12px] border-l-1 border-white ml-[13px] mr-[15px] usm:ml-[5px] usm:mr-[7px] uxs:hidden" />
                <span className="pointer-events-none uxs:hidden">{t('REGISTER')}</span>
            </button>

            {/* 背景遮罩 */}
            <Image
                className="gtm-btn-login set-center z-[1] w-full h-full trans group-hover:opacity-0 !filter-none"
                width={124}
                height={32}
                src="/images/icon/icon_login_bg.png"
                alt="background"
            />
            <div className="set-center z-[0] w-full h-full bg-bou" />
        </div>
    );
};

export default LoginButton;
